export default {
  title: "周六福供应商门户",
  subtitle: "供应商门户",
  copyright:
    "COPYRIGHT © 2014 ZLF　周六福珠宝股份有限公司 ALL RIGHTS RESERVED. ",
  companyRealm: "粤ICP备13087551号",
  police: "粤公网安备 44030302001449号",
  isFirstPage: true,
  key: "xydsupplier",
  allowList: ["/login", "/404", "/401", "/lock", "/feedback", "/upgrade"], // 配置无权限可以访问的页面
  allowTagList: ["/login", "/404", "/401", "/lock", "/upgrade"], // 配置不添加tags页面 （'/advanced-router/mutative-detail/*'——*为通配符）
  firstPage: {
    title: "工厂款式库",
    name: "FactoryStyle",
    path: "/factory/style",
    params: {},
    query: {},
    group: [],
    close: false,
  },
};
